<app-form-view [formDataModel]="customerPositionData"
    [formItems]="customerPositionFormItems"
    [showAddMore]="showAddMore"
    (onSave)="onSaveClicked($event)"
    (onCancel)="onCancelClicked($event)"
    (onAddMore)="onAddMoreClicked($event)"></app-form-view>
